import { useMe } from "../lib/me.tsx";
import { useT } from "../lib/i18n.tsx";

/** Banner for suspended / deleting accounts (T1.4). Banned users never get a session. */
export function AccountState() {
  const { me } = useMe();
  const t = useT();
  if (!me || me.status === "active") return null;
  const key =
    me.status === "suspended"
      ? "auth.state.suspended"
      : me.status === "deleting"
        ? "auth.state.deleting"
        : "auth.state.banned";
  return (
    <div className="banner banner--warn" role="status" data-testid="account-state">
      {t(key)}
    </div>
  );
}
